export function website({ url, name }) {
  return {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    url,
    name,
  }
}

export function organization({
  url,
  name,
  logo,
  foundingDate,
  founders,
  sameAs,
}) {
  if (!Array.isArray(founders)) {
    throw new Error('Please pass in an array of founder names')
  }
  return {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name,
    url,
    logo,
    foundingDate,
    founders: founders.map((name) => ({
      '@type': 'Person',
      name,
    })),
    sameAs,
  }
}

export function person({ name, url, socialProfiles }) {
  return {
    '@context': 'http://schema.org',
    '@type': 'Person',
    name,
    url,
    sameAs: socialProfiles,
  }
}

export function breadCrumbList({ sites, thumbnail }) {
  if (!Array.isArray(sites)) {
    throw new Error('Please pass in an array of URLs and names.')
  }
  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: sites.map(({ url, name }, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      item: {
        '@type': 'Thing',
        '@id': url,
        name,
        image: thumbnail,
      },
    })),
  }
}

export function socialProfile({ name, url, socialUrls }) {
  if (!Array.isArray(socialUrls)) {
    throw new Error('Please pass in an array of social URLs.')
  }
  return {
    '@context': 'http://schema.org',
    '@type': 'Person',
    name,
    url,
    sameAs: socialUrls,
  }
}

export function article({
  headline,
  alternativeHeadline,
  image,
  author,
  editor,
  genre,
  keywords,
  wordcount,
  publisher,
  url,
  datePublished,
  dateCreated,
  dateModified,
  shortDescription,
  articleBody,
  mainEntityOfPage,
}) {
  return {
    '@context': 'http://schema.org',
    '@type': 'Article',
    headline,
    alternativeHeadline,
    image,
    author,
    editor,
    genre,
    keywords,
    wordcount,
    publisher,
    url,
    datePublished,
    dateCreated,
    dateModified,
    description: shortDescription,
    articleBody,
    mainEntityOfPage,
  }
}

export function review({
  productImage,
  reviewTitle,
  reviewRatingValue,
  productName,
  reviewAuthor,
  reviewPublisher,
  datePublished,
  reviewBody,
}) {
  return {
    '@context': 'http://schema.org',
    '@type': 'Product',
    image: productImage,
    name: reviewTitle,
    review: {
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: reviewRatingValue,
      },
      name: productName,
      author: {
        '@type': 'Person',
        name: reviewAuthor,
      },
      datePublished,
      reviewBody,
      publisher: {
        '@type': 'Organization',
        name: reviewPublisher,
      },
    },
  }
}

export function blog({
  headline,
  alternativeHeadline,
  image,
  editor,
  genre,
  keywords,
  wordcount,
  publisher,
  url,
  datePublished,
  dateCreated,
  dateModified,
  description,
  articleBody,
  author,
  mainEntityOfPage,
}) {
  return {
    '@context': 'http://schema.org',
    '@type': 'BlogPosting',
    headline,
    alternativeHeadline,
    image,
    editor,
    genre,
    keywords,
    wordcount,
    publisher,
    url,
    datePublished,
    dateCreated,
    dateModified,
    description,
    articleBody,
    author: {
      '@type': 'Person',
      name: author,
    },
    mainEntityOfPage,
  }
}



// WEBPACK FOOTER //
// ./src/utils/meta.js